/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Application Form Ownership reducers.
 */
import { ReduxUtils } from '@spm/core';
import { combineReducers } from 'redux';
import * as ACTIONTYPES from './actionTypes';
/**
 * Updates the flag that is set while the change of ownership request is in progress.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */

function isChangingOwnershipReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, ACTIONTYPES.CHANGE_OWNERSHIP_ACTION_TYPES);
}
/**
 * Updates any post data errors that happened during the change of ownership.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */


function changeOwnershipErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ACTIONTYPES.CHANGE_OWNERSHIP_ACTION_TYPES);
}

var reducers = combineReducers({
  isChangingOwnership: isChangingOwnershipReducer,
  changeOwnershipError: changeOwnershipErrorReducer
});
export default {
  reducers: reducers
};